module.exports = __webpack_public_path__ + "img/performance-work-icon8.243df8ef.png";